import { useState } from 'react'

import useMediaQuery from '@material-ui/core/useMediaQuery'
import EditContextProvider from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import MuiDatables from 'Components/UI/Atoms/Table'
import AutocompleteFilter from 'Components/UI/Atoms/Table/Autocomplete'
import { CITIES, ESTADO_CLIENTE, PROVINCIAS, SUCURSAL_ORIGEN, TIPO_RESPONSABLE } from 'Constants'
import { interfaces } from 'service/interfaces'

import Edit from './Edit'

const ClientsTable = (props) => {
  const { render, setRender, dataBefore } = props

  const windowSize = useMediaQuery('(min-width:1000px)')
  const [loading, setLoading] = useState(false)

  const [values, setValues] = useState({
    rows: [],
    header: [],
  })

  const { state, setOpen, setClose } = SetState()

  async function apiCall(options, callback) {
    const params =
      typeof options === 'string'
        ? Object.fromEntries(new URLSearchParams(options))
        : { ...options }
    if (!params.origen) {
      params.origen = 'ECO'
    }
    const queryString = new URLSearchParams(params).toString()

    setValues({
      rows: [],
      header: [],
    })
    try {
      const result = await interfaces.salesClients.clientsList(`?${queryString}`)
      setValues({
        rows: result.data,
        header: result.header.header.count,
      })
      callback()
    } catch (error) {}
  }

  async function clientInfo(id) {
    const empresaString = values.rows.find((item) => item.id === id).origen
    const empresaId = SUCURSAL_ORIGEN.find((sucursal) => sucursal.label === empresaString).id

    await interfaces.salesClients.infoOneClient(id, empresaId).then((res) => {
      setOpen({
        data: res.data,
      })
    })
  }

  const RowsTransit = () =>
    values.rows.map((file) => [
      file.origen,
      file.cuit,
      file.nombre ?? file.razon_social ?? '',
      file.denominacion,
      file.estado,
      '',
    ])

  let columns = [
    {
      name: 'origen',
      label: 'Origen',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(values).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Origen"
                  filterName="label"
                  options={SUCURSAL_ORIGEN}
                  defaultOption={{ label: 'ECO', id: 1 }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'cuit',
      label: 'CUIT/CUIL/DNI',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'nombre',
      label: 'Razón social',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'denominacion',
      label: 'Nombre comercial',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'estado',
      label: 'Estado',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(values).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Estado"
                  filterName="label"
                  options={ESTADO_CLIENTE}
                  defaultOption={{ label: 'Activo' }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: '',
      label: '',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'tipo_responsable',
      label: 'Tipo de responsable',
      options: {
        filter: true,
        sort: false,
        display: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(values).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Tipo de responsable"
                  filterName="name"
                  options={TIPO_RESPONSABLE}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'provincia',
      label: 'Provincia',
      customBodyRender: true,
      options: {
        filter: true,
        sort: false,
        display: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterName: 'provincia',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(values).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Provincia"
                  filterName="provincia"
                  options={PROVINCIAS}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'localidad',
      label: 'Localidad',
      customBodyRender: true,
      options: {
        filter: true,
        sort: false,
        display: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterName: 'localidad',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(values).length > 0) {
              const filteredP = PROVINCIAS.filter((name) => name.provincia === filterList[7][0])
              const provinciaId = filteredP.length > 0 ? filteredP[0].id : null
              const filteredC = provinciaId
                ? CITIES.filter((item) => item.provincia_id === provinciaId)
                : []
              // const opcionesFormateadas = filteredC.map((item) => ({
              //   ...item,
              //   Localidad: `${item.localidad} (${item.cp})`
              // }))
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Localidad"
                  filterName="localidad"
                  fullWidth={true}
                  options={filteredC}
                />
              )
            }
          },
        },
      },
    },
  ]

  return (
    <>
      {state.suspense && (
        <EditContextProvider>
          <Edit
            open={state.open}
            handleclose={setClose}
            data={state.data}
            setRender={setRender}
            render={render}
            setLoading={setLoading}
            dataBefore={dataBefore}
            loading={loading}
          />
        </EditContextProvider>
      )}

      <MuiDatables
        columns={columns}
        data={RowsTransit()}
        title={`Total de clientes: ${values.rows.length}`}
        apiCall={apiCall}
        count={values.header}
        render={render}
        setRender={setRender}
        textPlaceholder="Buscar por razón social, nombre comercial o cuit..."
        onRowClick={(_, index) => clientInfo(values.rows[index.dataIndex].id)}
        padding={windowSize ? '10px' : ''}
      />
    </>
  )
}
export default ClientsTable
